import { render, staticRenderFns } from "./GPathCareerUnivEdit.vue?vue&type=template&id=6a704148&scoped=true"
import script from "./GPathCareerUnivEdit.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivEdit.vue?vue&type=script&lang=js"
import style0 from "./GPathCareerUnivEdit.vue?vue&type=style&index=0&id=6a704148&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a704148",
  null
  
)

export default component.exports